import { Box, TextField } from '@mui/material';
import * as React from 'react';

export default function CustomTextField(props) {
    const [text, setText] = React.useState(
        props?.value || '',
    );

    React.useEffect(() => {
        setText(props?.value || '');
    }, [props.value]);

    const textcss = {
        backgroundColor: 'white',
        borderRadius: '5px',
        '& input': {
            textAlign: 'center',
            fontSize: '11px',
            padding: '2px 0px !important',
        },
    };

    return (
        <Box sx={{ width: props.width || '100%', display: 'flex', alignItems: 'center', minWidth: 0 }}>
            <TextField
                fullWidth
                variant="standard"
                InputProps={{
                    disableUnderline: true,
                }}
                inputProps={{
                    maxLength: props.maxLength
                }}
                placeholder={props.placeholder || ''}
                sx={{
                    ...textcss,
                    margin: props.margin ? 0 : '0px 1px',
                    width: '100%',
                    px: 0.5,
                    border: "1px solid #919191"
                }}
                multiline={props.rows ? true : false}
                rows={props.rows || 1}
                disabled={!props.edit || false}
                value={text}
                onChange={(e) => {
                    let value = e.target.value.replace(/,/g, "");

                    // Only digits
                    if (props.inputType === "number") {
                      value = value.replace(/\D/g, "");
                    }
                
                    // Digits + one decimal
                    if (props.inputType === "decimal") {
                      value = value
                        .replace(/[^0-9.]/g, "")
                        .replace(/(\..*)\./g, "$1");
                    }
                
                    const formattedValue =
                      props.inputType === "text"
                        ? value
                        : value === ""
                        ? ""
                        : value.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                
                    setText(formattedValue);
                    if (props.setValue) {
                        props.setValue(formattedValue);
                    }
                }}
            />
        </Box>
    );
}
